import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getTeacherDashboardSummary = async () => {
  return serviceHelper(http.get('/teacher/dashboard/summary'), false);
};

export const getTeacherDashboardStudents = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/teacher/dashboard/students?${queryString}`),
    false
  );
};

export const getSchoolDashboardTopClasses = async () => {
  return serviceHelper(http.get('/school/dashboard/top-five-classes'), false);
};

export const getSchoolDashboardSummary = async () => {
  return serviceHelper(http.get('/school/dashboard/summary'), false);
};

// ─── Parent Dashboard APIs ───────────────────────────────────────────────────

export const getParentChildSummary = async (childId: string) => {
  return serviceHelper(http.get(`/parent/child/${childId}/summary`), false);
};

export const getParentChildGames = async (
  childId: string,
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/parent/child/${childId}/games?${queryString}`),
    false
  );
};

export const getParentChildGameDetail = async (
  childId: string,
  gameId: string
) => {
  return serviceHelper(
    http.get(`/parent/child/${childId}/game/${gameId}`),
    false
  );
};

export const getParentChildWeeklyActivity = async (
  childId: string,
  filter: number
) => {
  return serviceHelper(
    http.get(`/parent/child/${childId}/weekly-activity?filter=${filter}`),
    false
  );
};

export const getParentChildLearningActivityDistribution = async (
  childId: string
) => {
  return serviceHelper(
    http.get(`/parent/child/${childId}/learning-activity-distribution`),
    false
  );
};
